const abs = [
  {
    key: "Drunken Mountain Climbers",
    text: "Drunken Mountain Climbers",
    value: "Drunken Mountain Climbers",
  },
  {
    key: "Plank",
    text: "Plank",
    value: "Plank",
  },
  {
    key: "Russian V-tuck twists",
    text: "Russian V-tuck twists",
    value: "Russian V-tuck twists",
  },
  {
    key: "Starfish Crunch",
    text: "Starfish Crunch",
    value: "Starfish Crunch",
  },
  {
    key: "Seated Ab Circles",
    text: "Seated Ab Circles",
    value: "Seated Ab Circles",
  },
  {
    key: "Scissors",
    text: "Scissors",
    value: "Scissors",
  },
];

const back = [
  {
    key: "Lat Pull Down",
    text: "Lat Pull Down",
    value: "Lat Pull Down",
  },
  {
    key: "Low Row",
    text: "Low Row",
    value: "Low Row",
  },
  {
    key: "Pull Up",
    text: "Pull Up",
    value: "Pull Up",
  },
  {
    key: "Seated Row",
    text: "Seated Row",
    value: "Seated Row",
  },
  {
    key: "Straight Arm Cable Pulldown",
    text: "Straight Arm Cable Pulldown",
    value: "Straight Arm Cable Pulldown",
  },
];

const biceps = [
  {
    key: "Cable Curl",
    text: "Cable Curl",
    value: "Cable Curl",
  },
  {
    key: "Dumbbell Curl",
    text: "Dumbbell Curl",
    value: "Dumbbell Curl",
  },
  {
    key: "EZ Bar Curl",
    text: "EZ Bar Curl",
    value: "EZ Bar Curl",
  },
];

const chest = [
  {
    key: "Bench Press",
    text: "Bench Press",
    value: "Bench Press",
  },
  {
    key: "Dips",
    text: "Dips",
    value: "Dips",
  },
  {
    key: "Dumbbell Press",
    text: "Dumbbell Press",
    value: "Dumbbell Press",
  },
  {
    key: "Incline Dumbbell Press",
    text: "Incline Dumbbell Press",
    value: "Incline Dumbbell Press",
  },
  {
    key: "Incline Bench Press",
    text: "Incline Bench Press",
    value: "Incline Bench Press",
  },

  {
    key: "Pec deck fly",
    text: "Pec deck fly",
    value: "Pec deck fly",
  },
];

const legs = [
  {
    key: "Leg Curl",
    text: "Leg Curl",
    value: "Leg Curl",
  },
  {
    key: "Leg Extension",
    text: "Leg Extension",
    value: "Leg Extension",
  },
  {
    key: "Leg Press",
    text: "Leg Press",
    value: "Leg Press",
  },
  {
    key: "Squat",
    text: "Squat",
    value: "Squat",
  },
];

const shoulders = [
  {
    key: "Overhead Dumbbell Press",
    text: "Overhead Dumbbell Press",
    value: "Overhead Dumbbell Press",
  },
  {
    key: "Reverse Pec Deck Fly",
    text: "Reverse Pec Deck Fly",
    value: "Reverse Pec Deck Fly",
  },
  {
    key: "Side Lateral Raise",
    text: "Side Lateral Raise",
    value: "Side Lateral Raise",
  },
];

const triceps = [
  {
    key: "Tricep Extension",
    text: "Tricep Extension",
    value: "Tricep Extension",
  },
  {
    key: "Seated Tricep Press",
    text: "Seated Tricep Press",
    value: "Seated Tricep Press",
  },
];

const bodypartOptions = [
  {
    key: "Abs",
    text: "Abs",
    value: "Abs",
    workouts: abs,
  },
  {
    key: "Back",
    text: "Back",
    value: "Back",
    workouts: back,
  },
  {
    key: "Biceps",
    text: "Biceps",
    value: "Biceps",
    workouts: biceps,
  },
  {
    key: "Chest",
    text: "Chest",
    value: "Chest",
    workouts: chest,
  },
  {
    key: "Legs",
    text: "Legs",
    value: "Legs",
    workouts: legs,
  },
  {
    key: "Shoulders",
    text: "Shoulders",
    value: "Shoulders",
    workouts: shoulders,
  },
  {
    key: "Triceps",
    text: "Triceps",
    value: "Triceps",
    workouts: triceps,
  },
];

export default bodypartOptions;
